import Vue from "vue";
import Router from "vue-router";

import register from "@/view/register";
import login from "@/view/login";
import getPassword from "@/view/get_password";
import updatePassword from "@/view/update_password";

// 品牌
import brand from "@/view/brand/restaurant_list";
import restaurant_details from "@/view/brand/restaurant_details";

// 會員卡
import vipCard from "@/view/vipCard/index";
import my_coupon from "@/view/vipCard/my_coupon";
import integral from "@/view/vipCard/integral";
import integral_details from "@/view/vipCard/integral_details";

// 我的賬戶
import my from "@/view/my/index";

import inRecode from "@/view/integral/integral_recode";

import coupon_detail from "@/view/coupon/coupon_detail";

import update_phone from "@/view/update_phone";

import ad from "@/view/brand/ad";

import information from "@/view/information";

import menu from "@/view/vipCard/menu";

import map from "@/view/brand/map";

import reservation from "@/view/brand/reservation";

import reservation_detail from "@/view/brand/reservation_detail";

import reservation_list from "@/view/brand/reservation_list";

import test from "@/view/test/test";

Vue.use(Router);

export default new Router({
  routes: [
    // 匹配不到重定向到首页
    {
      path: "*",
      redirect: "/"
    },
    // 會員卡首頁
    {
      path: "/:arg?",
      name: "vipCard",
      component: vipCard
    },
    {
      path: "/my_coupon/:arg",
      name: "my_coupon",
      component: my_coupon
    },
    {
      // path: '/integral/:s',
      path: "/integral/:arg",
      name: "integral",
      component: integral
    },
    {
      path: "/integral_details/:arg",
      name: "integral_details",
      component: integral_details
    },

    // 註冊頁
    {
      path: "/register/:arg",
      name: "register",
      component: register
    },
    // 登錄頁
    {
      path: "/login/:arg",
      name: "login",
      component: login
    },
    // 獲取密碼
    {
      path: "/get_password/:arg",
      name: "get_password",
      component: getPassword
    },
    // 修改密碼
    {
      path: "/update_password/:arg",
      name: "update_password",
      component: updatePassword
    },
    // 品牌模塊
    {
      path: "/brand/:arg",
      name: "brand",
      component: brand
    },
    {
      path: "/restaurant_details/:arg",
      name: "restaurant_details",
      component: restaurant_details
    },

    // 我的賬戶模塊
    {
      path: "/my/:arg",
      name: "my",
      component: my
    },
    //  積分記錄
    {
      path: "/integral_recode/:arg",
      name: "integral_recode",
      component: inRecode
    },
    // 優惠券詳情
    {
      path: "/coupon_detail/:arg",
      name: "coupon_detail",
      component: coupon_detail
    },
    // 修改號碼
    {
      path: "/update_phone/:arg",
      name: "update_phone",
      component: update_phone
    },
    // 廣告頁
    {
      path: "/ad/:arg",
      name: "ad",
      component: ad
    },
    // 完善信息頁
    {
      path: "/information/:arg",
      name: "information",
      component: information
    },
    {
      path: "/menu",
      name: "menu",
      component: menu
    },
    {
      path: "/map/:arg",
      name: "map",
      component: map
    },
    {
      path: "/reservation/:arg",
      name: "reservation",
      component: reservation
    },
    {
      path: "/reservation_detail:arg",
      name: "reservation_detail",
      component: reservation_detail
    },
    {
      path: "/reservation_list/:arg",
      name: "reservation_list",
      component: reservation_list
    },
    {
      path: "/recommendation/:arg",
      name: "recommendation",
      component: () => import("@/view/my/recommendation")
    },
    {
      path: "/share/:arg",
      name: "share",
      component: () => import("@/view/my/share")
    },
    {
      path: "/noServer/:arg",
      name: "noServer",
      component: () => import("@/view/noServer")
    },
    {
      path: "/test",
      name: "test",
      component: test
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js